import {h, Fragment} from "preact"
import { defaultConfig, popularSearches } from "../config"
import { HistoryElement, useAppStateSelector } from "@nosto/preact"

export default function History() {
    const historyItems = useAppStateSelector(state => state.historyItems)

    // if (!historyItems || !historyItems.length) {
    //     return
    // }

    return (
        <div class="ns-autocomplete ns-history ns-fixed ns-d-flex ns-flex-column ns-flex-sm-row ns-justify-content-center ns-align-items-start ns-background-white ns-border-box ns-mx-auto">
            {popularSearches && <div class="ns-w-100 ns-mt-sm-auto">
                <div class="ns-history-heading ns-color-black ns-px-2 ns-font-bold ns-font-6">
                    Popular Searches
                </div>
                <div class="ns-d-flex ns-flex-column ns-history-search-container ns-px-2">
                    {/* {historyItems?.slice(0, defaultConfig.historySize).map(item => (
                        <HistoryElement key={item} query={{ query: item }}>
                            <div class="ns-d-flex flex-row ns-justify-content-between ns-clickable ns-py-2 ns-px-4 ns-font-4">
                                {item}
                            </div>
                        </HistoryElement>
                    ))} */}

                    {(window.nostoPopularSearches || popularSearches).map((item, index)=>{
                        return (
                            <a href={item?.url} class="ns-history-search ns-d-block ns-font-6">{item?.name}</a>
                        )
                    })}
                </div>
            </div>}
        </div>
    )
}
